import { useEffect, useMemo, useState } from "react";
import DonutChart from "./donutChart";
import { useElementSize } from "usehooks-ts";
import { useDispatch, useSelector } from "react-redux";
import { addWidgetToFilterList } from "../../../state/features/analytics/actions";
import Widget from "../../baseWidget";
import { useWidgetContext } from "../../../helpers/hooks/useWidgetContext";
import { RootState } from "../../../state/store";

const DonutChartWidget = () => {
  const [widgetData, setWidgetData] = useState<any>({});
  const [chartContainerRef, chartDimensions] = useElementSize();

  const widget = useWidgetContext();
  let dispatch = useDispatch();

  const { widgets: widgetFilters } = useSelector(
    (state: RootState) => state.filters
  );

  const widgetSeriesData = useMemo(() => {
    if (widgetData && widgetData?.widget_data) {
      return widgetData.widget_data.data.series;
    }
    return [];
  }, [JSON.stringify(widgetData)]);

  useEffect(() => {
    if (widget.widgetData.widget_data) {
      const widgetFilterExists = widgetFilters.find(
        (i) => i.key == widget?.widgetFilterConfig?.widgetFilterKey
      );
      if (
        widget.widgetFilterConfig.enableFilters &&
        !widgetFilterExists
      ) {
        dispatch(
          addWidgetToFilterList({
            name: widget.widgetFilterConfig.filterTitle,
            filterKey: widget.widgetFilterConfig.widgetFilterKey,
            options: widget.widgetData.widget_data.data.series.map((d) => ({
              id: d.id,
              name: d.category,
            })),
          })
        );
      }
      setWidgetData(widget.widgetData);
    }
  }, [widget.widgetData]);

  return (
    <Widget ref={chartContainerRef}>
      <Widget.Header>
        <Widget.Title>{widgetData?.title}</Widget.Title>
        {widgetSeriesData.length > 0 ? <Widget.ExtendedAReportCta /> : null}
      </Widget.Header>
      <Widget.Content>
        {widgetSeriesData.length > 0 ? (
          <DonutChart
            width={chartDimensions.width - 50}
            height={chartDimensions.height - 90}
            data={widgetData.widget_data}
          />
        ) : (
          <Widget.EmptyData
            width={chartDimensions.width - 50}
            height={chartDimensions.height - 90}
          />
        )}
      </Widget.Content>
    </Widget>
  );
};

export default DonutChartWidget;
